import { SessionContextValue, useSession } from 'next-auth/react';
import { Session } from 'next-auth';
import { SessionsData } from '../../auth/sessionTypes';
import selectSessionContent from '../../store/session/selectors/selectSessionContent';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export default function useNextAuthOrSession(): SessionsData {
  const contextSession: SessionContextValue = useSession();
  const session = useSelector(selectSessionContent);

  return useMemo((): SessionsData => {
    let authSession: Session | null = null;

    if (contextSession.data) {
      authSession = contextSession.data;
    }
    return {
      authSession,
      session
    };
  }, [contextSession.data, session]);
}
